import React from 'react';
import { View } from '@amzn/atoz-web/View';
import { LoadingButton } from '../../shared';
import { ModalContent } from '@amzn/atoz-web/Modal';
import { ButtonVariant } from '@amzn/atoz-web/Button';
import { SpinnerColorScheme } from '@amzn/atoz-web/Spinner';
import { useTranslation } from 'react-i18next';
export var AcceptVtoModal = function (_a) {
    var acceptVtoMutation = _a.acceptVtoMutation, acceptVtoIsSubmitting = _a.acceptVtoIsSubmitting, close = _a.close, vtoMessage1 = _a.vtoMessage1, vtoMessage2 = _a.vtoMessage2, vtoDescription = _a.vtoDescription;
    var t = useTranslation().t;
    var vtoOpportunityMessage = (React.createElement(React.Fragment, null,
        vtoMessage1,
        " ",
        React.createElement("strong", null, vtoDescription),
        " ",
        vtoMessage2));
    return (React.createElement(ModalContent, { dataTestId: "AcceptVtoConfirmation", titleText: t('shift_management_features_VtoAcceptConfirmationModal_vtoAccept'), onCloseButtonClick: close, buttons: [
            React.createElement(LoadingButton, { buttonVariant: ButtonVariant.Primary, spinnerColor: SpinnerColorScheme.Inverted, onClick: acceptVtoMutation, loading: acceptVtoIsSubmitting, dataTestId: "AcceptVtoConfirmButton", key: "Accept", buttonText: t('shift_management_features_VtoAcceptConfirmationModal_vtoAcceptButton') })
        ] },
        React.createElement(View, null, vtoOpportunityMessage)));
};
